import React from 'react';
import {motion} from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const {FiShield, FiArrowRight} = FiIcons;

const HeroSection = () => {
  const scrollToContact = () => {
    document.getElementById('contact').scrollIntoView({behavior: 'smooth'});
  };

  return (
    <section className="relative bg-gradient-to-br from-blue-50 to-white min-h-screen flex items-center">
      <div className="container mx-auto px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          {/* Left Content */}
          <motion.div
            initial={{opacity: 0, x: -50}}
            animate={{opacity: 1, x: 0}}
            transition={{duration: 0.8}}
            className="space-y-8"
          >
            <div className="inline-flex items-center px-4 py-2 bg-blue-100 text-blue-800 rounded-full text-sm font-medium">
              <SafeIcon icon={FiShield} className="mr-2" />
              30+ Years Defending California Businesses
            </div>
            
            <h1 className="text-5xl lg:text-6xl font-bold text-gray-900 leading-tight">
              Aggressive Legal Defense for 
              <span className="text-blue-600 block">California Employers</span>
            </h1>
            
            <p className="text-xl text-gray-600 leading-relaxed">
              John Fagerholm exclusively represents California businesses against unfair labor laws. 
              With over 30 years of experience, we fight aggressively to protect your business from 
              frivolous employee claims and regulatory overreach.
            </p>
            
            <div className="flex flex-col sm:flex-row gap-4">
              <motion.button
                whileHover={{scale: 1.05}}
                whileTap={{scale: 0.95}}
                onClick={scrollToContact}
                className="bg-blue-600 text-white px-8 py-4 rounded-lg font-semibold text-lg hover:bg-blue-700 transition-colors flex items-center justify-center group"
              >
                Get Started
                <SafeIcon icon={FiArrowRight} className="ml-2 group-hover:translate-x-1 transition-transform" />
              </motion.button>
              
              <motion.a
                whileHover={{scale: 1.05}}
                whileTap={{scale: 0.95}}
                href="tel:323-990-8118"
                className="border-2 border-gray-300 text-gray-700 px-8 py-4 rounded-lg font-semibold text-lg hover:border-gray-400 transition-colors text-center"
              >
                Call (323) 990-8118
              </motion.a>
            </div>
          </motion.div>
          
          {/* Right Content */}
          <motion.div
            initial={{opacity: 0, x: 50}}
            animate={{opacity: 1, x: 0}}
            transition={{duration: 0.8, delay: 0.2}}
            className="relative"
          >
            <div className="relative z-10">
              <img
                src="/src/assets/attorney-image.png"
                alt="Professional attorney in brown suit"
                className="rounded-2xl shadow-2xl w-full"
              />
            </div>
            <div className="absolute -top-4 -right-4 w-full h-full bg-blue-200 rounded-2xl -z-10"></div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;